package one.healthium.bland.providers

import ifaandroid.apps.bland.composeapp.generated.resources.Res
import ifaandroid.apps.bland.composeapp.generated.resources.ic_checkmark_checked
import ifaandroid.apps.bland.composeapp.generated.resources.ic_checkmark_unchecked
import one.healthium.ui.compose.components.IconsProvider
import org.jetbrains.compose.resources.DrawableResource

class AppIconsProvider : IconsProvider {
    override val icCheckMarkChecked: DrawableResource = Res.drawable.ic_checkmark_checked
    override val icCheckMarkUnchecked: DrawableResource = Res.drawable.ic_checkmark_unchecked
}